<template>
	<div class="answer-app">
		<!--nav-->
		<div class="detail-nav">
			<a @click="jumpList()">
				<img src="images/index.png" />首页
			</a>
			<a @click="jumpList()">{{category_name}}</a>
			<a @click="jumpList()">{{chapter}}</a>
			<span>{{chapter_sub}}</span>
		</div>

		<!-- answer -->
		<div class="answer-box">
			<div class="answer-box-left">
				<div class="answer-title">
					<p>
						<span>
							<i>{{page}}</i>/
							<i>{{count}}</i>
						</span>
						<em>{{data[page-1].name}}</em>
					</p>
					<strong>
						<em>{{chapter_sub}}</em>
					</strong>
					<button class="answer-title-que" @click="showQueWin = true">答疑</button>
					<el-dialog :visible.sync="showQueWin" width="400px">
						<div class="win-que">
							<img src="/images/an_11.png" alt />
							<div>
								<img src="/images/qun.png" alt />
							</div>扫二维码加入答疑QQ群
						</div>
					</el-dialog>
					<button class="answer-title-wrong" @click="openWrongWin">纠错</button>
					<el-dialog :visible.sync="showWrongWin" width="480px">
						<div class="win-wrong">
							<h3>纠错</h3>
							<el-form>
								<el-form-item>
									<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容" maxlength="200" show-word-limit></el-input>
								</el-form-item>
								<el-button type="primary" @click="errorCorrection()">确认</el-button>
							</el-form>
						</div>
					</el-dialog>
					<button class="answer-title-col" :class="{'col-active': data[page-1].favorite===1}" @click="setCollect()">收藏</button>
				</div>

				<!-- 题目 -->
				<div v-if="category_name==='数学'" class="answer-que" :class="{'answer-gap':fillInTheBlankQuestionType.includes(item.genre),'answer-title-img':item.icon,'answer-word':titleHeight >=121 && index == page-1}"
				 v-for="(item,index) in data" :key="item.id" v-show="index===page-1">
					<div class="answer-que-title">
						<xmp :class="{'answer-que-title-xmp':isUnfold} " v-if="!(fillInTheBlankQuestionType.includes(item.genre))" ref="xmpHeight">{{item.text?item.text:item.title}}</xmp>
						<aside :class="{'answer-que-title-xmp':isUnfold}" v-else v-html="item.title" ref="xmpHeight"></aside>
						<div class="demo-image__preview" v-if="item.icon">
							<el-image style="width: 100%; height: 100%" :src="item.icon" :preview-src-list="titleSrcList"></el-image>
						</div>
						<p @click="setTitleUnfold">{{setTitleText}}</p>
					</div>
					<div class="answer-que-option">
						<div class="answer-que-option-title" v-show="item.text">{{item.title}}</div>
						<!-- 单选题start -->
						<p :class="{right:answerTrueArray[page]==answerOption[k],wrong:answerArray[page]==answerOption[k]}" v-show="multipleChoiceQuestions.includes(item.genre)"
						 v-for="(v,k) in item.option" @click="showParsing==false && multipleChoice($event)">
							<em>{{answerOption[k]}}</em>
							<xmp>{{v}}</xmp>
						</p>
						<!-- 单选题end -->
						<!-- 多选题start -->
						<p :class="{right:right.includes(answerOption[k]),wrong:wrong.includes(answerOption[k]),cover:cover.includes(answerOption[k])}"
						 @click="showParsing==false && multipleChoices($event)" v-show="multipleChoicesQuestions.includes(item.genre)"
						 v-for="(v,k) in item.option">
							<em>{{answerOption[k]}}</em>
						
							<xmp v-if="v.indexOf('http')==-1" >{{v}}</xmp>
						  <xmp v-else> <img:src="v"  referrerpolicy="no-referrer" alt=""></xmp> 
						</p>
						<!-- 多选题end -->
						<!-- 填空题start -->
						<!-- <p v-if="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('_____')).length - 1"> -->
						<p v-if="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('_____')).length - 1"
						 :key="v">
							<em>{{v}}</em>
							<el-form :model="formOption">
								<el-form-item>
									<el-input v-model="formOption[k]" placeholder="请输入答案" :readonly="showParsing"></el-input>
								</el-form-item>
							</el-form>
						</p>
						<p v-show="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('<span')).length - 1"
						 :key="v">
							<em>{{v}}</em>
							<el-form :model="fillInTheBlankAnswer">
								<el-form-item>
									<el-input v-model="fillInTheBlankAnswer[k]" placeholder="请输入答案" :readonly="showParsing"></el-input>
								</el-form-item>
							</el-form>
						</p>
						<!-- 填空题end -->
						<!-- 简答题start -->
						<p :class="{right:answerArray[page]=='会'}" v-show="shortAnswerQuestionType.includes(item.genre)" class="willnot"
						 @click="showParsing==false && meetingWillNot($event)">
							<em>?</em>
							<xmp>会</xmp>
						</p>
						<!-- 简答题end -->
						<p :class="{wrong:answerArray[page]=='不会'}" class="willnot" @click="showParsing==false && meetingWillNot($event)">
							<em>?</em>
							<xmp>不会</xmp>
						</p>
					</div>
					<!-- 多选题start -->
					<div class="answer-que-option-btn" v-show="multipleChoicesQuestions.includes(item.genre)">
						<el-button type="success" @click="multipleChoicesDetermine($event)">确认</el-button>
					</div>
					<!-- 多选题end -->
					<!-- 填空题start -->
					<div class="answer-que-option-btn" v-show="fillInTheBlankQuestionType.includes(item.genre)">
						<el-button type="success" @click="showParsing==false && fillInTheBlank()">确认</el-button>
					</div>
					<!-- 填空题end -->
					<div class="answer-que-btn">
						<el-button class="answer-prev" :class="{'el-button--primary':page!==1}" :disabled="page===1" @click="previousQuestion()">上一题</el-button>
						<el-button class="answer-parsing" @click="showParsing==false && viewResolution()">
							<img src="/images/an_4.png" />查看答案与解析
						</el-button>
						<el-button v-if="page==count" class="el-button--primary answer-next" @click="nextQuestion()">提交</el-button>
						<el-button v-else class="el-button--primary answer-next" @click="nextQuestion()">下一题</el-button>
					</div>

					<!-- 解析 -->
					<div class="parsing" v-show="showParsing">
						<div class="parsing-title" style="display: flex;justify-content: space-between;">
							<div>
								<span>解析</span>
								<span>
									正确答案：
									<em>{{item.answer}}</em>
								</span>
								<span class="wrong">
									你的答案：
									<em>{{answerArray[page]}}</em>
								</span>
							</div>
							<div>
								全站正确率：<i style="color: #ff6c6c;font-style: normal;">{{item.right_rate}}%</i>
							</div>
						</div>
						<xmp>{{item.analysis}}</xmp>
					</div>

					<!-- 笔记 -->
					<div class="answer-note" v-show="showNote">
						<div class="parsing-title">本题笔记</div>
						<aside>
							<p>
								<el-input type="textarea" v-model="noteValue" maxlength="200" rows="3" placeholder="请输入笔记内容" show-word-limit
								 ></el-input>
								<!-- <textarea placeholder="请输入笔记内容" rows="3" v-model="noteValue" maxlength="200"></textarea> -->
							</p>
							<el-button type="primary" size="small" @click="addnote()">保存</el-button>
						</aside>

						<div class="answer-note-list">
							<div class="note-list" v-for="(vv,kk) in item.note" :key="vv.id">
								<div class="note-list-tit">
									<div class="note-list-photo">
										<el-avatar :size="50" :src="vv.image"></el-avatar>
									</div>
									<div class="note-list-info">
										<p style="margin-top:4px">{{vv.nickname}}</p>
										<p>{{vv.update_time*1000|formatDate}}</p>
									</div>
									<button v-show='vv.user_id ==userid '  class="note-list-dete" title="删除" @click="deleteNote(vv.id,item.id)">删除</button>
									<!-- <button v-show="vv.uid!=user_id" class="note-list-praise" :class="{'note-list-active':''}" @click="praiseNote($event,vv.id)">{{vv.praise}}</button> -->
								</div>
								<div class="note-list-text"><pre>{{vv.content}}</pre> </div>
							</div>
							<button class="answer-list-more" v-show="item.note && item.note.length>4" @click="loadMoreNotes()">加载更多笔记</button>
						</div>
					</div>
				</div>
				<!-- end -->

				<!-- 题目 -->
				<div v-if="category_name!=='数学'" class="answer-que" :class="{'answer-gap':fillInTheBlankQuestionType.includes(item.genre),'answer-title-img':item.icon,'answer-word':titleHeight >=120 && index == page-1}"
				 v-for="(item,index) in data" :key="item.id" v-show="index===page-1">
					<div class="answer-que-title">
						<xmp :class="{'answer-que-title-xmp':isUnfold} " v-if="!(fillInTheBlankQuestionType.includes(item.genre))" ref="xmpHeight">{{item.text?item.text:item.title}}</xmp>
						<aside :class="{'answer-que-title-xmp':isUnfold}" v-else v-html="item.title" ref="xmpHeight"></aside>
						<div class="demo-image__preview" v-if="item.icon">
							<el-image style="width: 100%; height: 100%" :src="item.icon" :preview-src-list="titleSrcList"></el-image>
						</div>
						<p @click="setTitleUnfold">{{setTitleText}}</p>
					</div>
					<div class="answer-que-option">
						<div class="answer-que-option-title" v-show="item.text">{{item.title}}</div>
						<!-- 单选题start -->
						<p :class="{right:answerTrueArray[page]==answerOption[k],wrong:answerArray[page]==answerOption[k]}" v-show="multipleChoiceQuestions.includes(item.genre)"
						 v-for="(v,k) in item.option" @click="showParsing==false && multipleChoice($event)">
							<em>{{answerOption[k]}}</em>
		
							<span v-if="v.indexOf('http')==-1" >{{v}}</span>
						  <span v-else> <img:src="v"  referrerpolicy="no-referrer" alt=""></span> 
						</p>
						<!-- 单选题end -->
						<!-- 多选题start -->
						<p :class="{right:right.includes(answerOption[k]),wrong:wrong.includes(answerOption[k]),cover:cover.includes(answerOption[k])}"
						 @click="showParsing==false && multipleChoices($event)" v-show="multipleChoicesQuestions.includes(item.genre)"
						 v-for="(v,k) in item.option">
							<em>{{answerOption[k]}}</em>
							<span v-if="v.indexOf('http')==-1" >{{v}}</span>
						  <span v-else> <img:src="v"  referrerpolicy="no-referrer" alt=""></span> 
						</p>
						<!-- 多选题end -->
						<!-- 填空题start -->
						<!-- <p v-if="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('_____')).length - 1"> -->
						<p v-if="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('_____')).length - 1"
						 :key="v">
							<em>{{v}}</em>
							<el-form :model="formOption">
								<el-form-item>
									<el-input v-model="formOption[k]" placeholder="请输入答案" :readonly="showParsing"></el-input>
								</el-form-item>
							</el-form>
						</p>
						<p v-show="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in (item.title.split('<span')).length - 1"
						 :key="v">
							<em>{{v}}</em>
							<el-form :model="fillInTheBlankAnswer">
								<el-form-item>
									<el-input v-model="fillInTheBlankAnswer[k]" placeholder="请输入答案" :readonly="showParsing"></el-input>
								</el-form-item>
							</el-form>
						</p>
						<!-- 填空题end -->
						<!-- 简答题start -->
						<p :class="{right:answerArray[page]=='会'}" v-show="shortAnswerQuestionType.includes(item.genre)" class="willnot"
						 @click="showParsing==false && meetingWillNot($event)">
							<em>?</em>
							<xmp>会</xmp>
						</p>
						<!-- 简答题end -->
						<p :class="{wrong:answerArray[page]=='不会'}" class="willnot" @click="showParsing==false && meetingWillNot($event)">
							<em>?</em>
							<xmp>不会</xmp>
						</p>
					</div>
					<!-- 多选题start -->
					<div class="answer-que-option-btn" v-show="multipleChoicesQuestions.includes(item.genre)">
						<el-button type="success" @click="multipleChoicesDetermine($event)">确认</el-button>
					</div>
					<!-- 多选题end -->
					<!-- 填空题start -->
					<div class="answer-que-option-btn" v-show="fillInTheBlankQuestionType.includes(item.genre)">
						<el-button type="success" @click="showParsing==false && fillInTheBlank()">确认</el-button>
					</div>
					<!-- 填空题end -->
					<div class="answer-que-btn">
						<el-button class="answer-prev" :class="{'el-button--primary':page!==1}" :disabled="page===1" @click="previousQuestion()">上一题</el-button>
						<el-button class="answer-parsing" @click="showParsing==false && viewResolution()">
							<img src="/images/an_4.png" />查看答案与解析
						</el-button>
						<el-button v-if="page==count" class="el-button--primary answer-next" @click="nextQuestion()">提交</el-button>
						<el-button v-else class="el-button--primary answer-next" @click="nextQuestion()">下一题</el-button>
					</div>

					<!-- 解析 -->
					<div class="parsing" v-show="showParsing">
						<div class="parsing-title">
							<span>解析</span>
							<span>
								正确答案：
								<em>{{item.answer}}</em>
							</span>
							<span :class="item.answer == answerArray[page] ?'':'wrong' ">
								你的答案：
								<em>{{answerArray[page]}}</em>
							</span>
						</div>
						<p v-html="item.analysis" style="padding: 20px;">{{item.analysis}}</p>
					</div>

					<!-- 笔记 -->
					<div class="answer-note" v-show="showNote">
						<div class="parsing-title">本题笔记</div>
						<aside>
							<p>
								<el-input type="textarea" v-model="noteValue" maxlength="200" rows="3" placeholder="请输入笔记内容" show-word-limit></el-input>
								<!-- <textarea placeholder="请输入笔记内容" rows="3" v-model="noteValue" maxlength="200"></textarea> -->
							</p>
							<el-button type="primary" size="small" @click="addnote()">保存</el-button>
						</aside>

						<div class="answer-note-list">
							<div class="note-list" v-for="(vv,kk) in item.note" :key="vv.id">
								<div class="note-list-tit">
									<div class="note-list-photo">
										<el-avatar :size="50" :src="vv.image"></el-avatar>
									</div>
									<div class="note-list-info">
										<p style="margin-top:4px">{{vv.nickname}}</p>
										<p>{{vv.update_time*1000|formatDate}}</p>
									</div>
									<button v-show='vv.user_id ==userid '  class="note-list-dete" title="删除" @click="deleteNote(vv.id,item.id)">删除</button>
									<!-- <button v-show="vv.uid!=user_id" class="note-list-praise" :class="{'note-list-active':''}" @click="praiseNote($event,vv.id)">{{vv.praise}}</button> -->
								</div>
								<div class="note-list-text"><pre>{{vv.content}}</pre> </div>
							</div>
							<button class="answer-list-more" v-show="item.note && item.note.length>4" @click="loadMoreNotes()">加载更多笔记</button>
						</div>
					</div>
				</div>
				<!-- end -->
			</div>

			<div class="answer-box-right">
				<!--时间 返回-->
				<div class="answer-time">
					<p>
						<img src="images/an_2.png" />
						<span>{{timeStr}}</span>
					</p>
					<a title="返回" @click="jumpList()">
						<img src="images/an_3.png" />
					</a>
				</div>

				<!--答题卡-->
				<div class="answer-card">
					<h3>
						<img src="images/an_7.png" /> 答题卡
					</h3>
					<div class="card card-a">
						<el-button v-for="v in count" :key="v" @click="Answersheet(v)" :class="{right:cacheAnswer[v-1] && cacheAnswer[v-1]['res']==1,wrong:cacheAnswer[v-1] && cacheAnswer[v-1]['res']==0}">{{v}}</el-button>
					</div>
					<el-button type="primary" class="card-sub" @click="stopKeepTime">提交</el-button>
				</div>

				<!--相关推荐-->
				<div class="answer-recom">
					<h3>
						<img src="images/an_5.png" /> 相关推荐
					</h3>
					<dl v-for="item in book" :key="item.id">
						<a @click="jump(item.id)">
							<dt>
								<img :src="'https://www.sz517.com'+item.icon" />
							</dt>
							<dd>{{item.name}}</dd>
							<p>￥{{item.price}}</p>
						</a>
					</dl>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import test from "../../../public/css/test.css";
	export default {
		name: "answer-app",
		data() {
			return {
				data: [],
				uid:'',
				page: 1,
				sub_id: 0,
				ques_id: 0,
				category_name: "",
				chapter: "",
				chapter_sub: "",
				path: "",
				count: 0,
				multipleChoiceQuestions: [
					1,
					3,
					4,
					5,
					7,
					8,
					9,
					1001,
					1003,
					1004,
					1101,
					1104,
					1201,
					1301,
					1304,
				], //单选题题型
				multipleChoicesQuestions: [2, 1002, 1102, 1302], //多选题题型
				fillInTheBlankQuestionType: [6, 1206], //填空题题型
				shortAnswerQuestionType: [4, 5, 7, 8, 9, 1004, 1104, 1304], //简答题题型
				answerOption: ["A", "B", "C", "D", "E", "F", "G"],
				book: [],
				numberOfNotes: 1,
				numberOfHorizontalLines: 0,
				cacheAnswer: [], //缓存答案
				answerArray: [],
				answerTrueArray: [],
				right: [],
				wrong: [],
				cover: [],
				fillInTheBlankAnswer: {},
				titleUrl: "",
				titleSrcList: ["/images/a2.png"],
				btnDisabled: true, //禁用prev  next按钮
				noteValue: "", //笔记文本框
				wrongValue: "", //纠错文本框
				selectedValue: "1",
				testType: "3", // 0单选 1多选 2填空 3阅读
				formOption: {},
				isUnfold: false, //是否展开
				setTitleText: "展开文章",
				showParsing: false, //显示解析
				showNote: false, //显示笔记
				showQueWin: false,
				showWrongWin: false,
				isCollect: false, //收藏
				h: 0,
				m: 0,
				uid:'',
				s: 0,

				timeStr: "",
				timer: null,
				praiseActive: false,
				scroll: "",
				titleHeight: "",
				zhuId
			};
		},
		filters: {
			formatDate: function(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? "0" + MM : MM;
				let d = date.getDate();
				d = d < 10 ? "0" + d : d;
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				let s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
			},
		},
		
		created() {
			this.getuserid()
			this.$loading(true);
			this.startTime();
			this.sub_id = this.$route.query.sub_id;
			this.cateCrumbs();
		},
		methods: {


			jumpList() {
				this.$confirm("您确定要离开当前页面吗？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$router.push({
							path: "/",
						});
					})
					.catch(() => {});
			},
			//提交试卷
			stopKeepTime() {
			if (this.cacheAnswer == undefined || this.cacheAnswer.length < this.data.length) {
					this.$message({
						type: "success",
						message:  this.cacheAnswer==undefined ? "不能交白卷哟！":"还有题没有做哦",
						showClose: true,
					});
					return;
				}
				this.stopTime();
				this.$confirm("您确定要结束答题吗？", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						for (var i = 0; i < this.count; i++) {
							if (!this.cacheAnswer[i]) {
								this.cacheAnswer[i] = {};
								this.cacheAnswer[i]["id"] = this.data[i].id;
								this.cacheAnswer[i]["text"] = this.data[i].text;
								this.cacheAnswer[i]["title"] = this.data[i].title;
								this.cacheAnswer[i]["score"] = this.data[i].score;
								this.cacheAnswer[i]["pid"] = this.data[i].pid;
								this.cacheAnswer[i]["genre"] = this.data[i].genre;
								this.cacheAnswer[i]["analysis"] = this.data[i].analysis;
								this.cacheAnswer[i]["option"] = this.data[i].option;
								this.cacheAnswer[i]["icon"] = this.data[i].icon;
								this.cacheAnswer[i]["genre_type"] = this.data[i].name;
								this.cacheAnswer[i]["user_res"] = "未作答";
								this.cacheAnswer[i]["succ_res"] = this.data[i].answer;
								this.cacheAnswer[i]["res"] = 0;
							}
						}
						// //console.log(this.cacheAnswer)
						var param = {
							aid: this.ques_id,
							path: this.path,
							uid: this.user_id,
							time: this.h * 60 * 60 + this.m * 60 + this.s,
							result: this.cacheAnswer,
							sub_id: this.sub_id,
							type: 1,
						};
						this.$post("submitSpecialItem", param).then((res) => {
							//console.log(res);
							if (res.data.id) {
								localStorage.setItem("answerOptions", null);
								this.$router.push({
									path: "/result",
									query: {
										result_id: res.data.id,
										sub_id: this.sub_id,
									},
								});
							} else {
								this.$message({
									type: "error",
									message: "request failed!please try again later",
									showClose: true,
								});
							}
						});
					})
					.catch(() => {
						// clearInterval(this.timer);
						this.startTime();
					});
			},

			//获取初始数据
			getInitialData() {
				var param = {
					ques_id: this.ques_id,
					uid: this.user_id,
					page: this.page,
				};

				this.$post("specialItem", param).then((res) => {
					// //console.log(res.data);
					this.$loading().close();
					this.data = res.data;
					this.noteValues();
					this.count = res.data.length;
					this.mathJax();
				});
			},
			//转换数学公式
			mathJax() {
				let _this = this;
				setTimeout(function() {
					if (_this.commonsVariable.isMathjaxConfig) {
						//判断是否初始配置，若无则配置。
						_this.commonsVariable.initMathjaxConfig();
					}
					_this.commonsVariable.MathQueue("searchTextJson"); //传入组件id，让组件被MathJax渲染
				}, 500);
			},
			//点击查看解析触发
			viewResolution() {

					if(i !== 'u'){
					 this.uid= id 	 
					 //console.log(this.uid)
				 }
				 else{
					 id =this.uid
				 }
				this.showParsing = true;
				this.showNote = true;
				var answer = "";
				if (this.fillInTheBlankQuestionType.includes(this.data[this.page - 1].genre)) {//填空题
					var num = this.data[this.page - 1].title.split("_____").length - 1;
					if (num > 1) {//多空
						var dd = this.data[this.page - 1].answer.split(",");
						for (var i = 0; i < num; i++) {
							this.fillInTheBlankAnswer[i] = dd[i];
							if (this.formOption[i]) {
								if (dd[i] == this.formOption[i].replace(/(^\s*)|(\s*$)/g, "")) {
									this.data[this.page - 1].title = this.data[
										this.page - 1
									].title.replace(
										"_____",
										"<span style='color:skyblue'>" +
										this.formOption[i] +
										"</span>"
									);
								} else {
									this.data[this.page - 1].title = this.data[
										this.page - 1
									].title.replace(
										"_____",
										"<span style='color:red'>" + this.formOption[i] + "</span>"
									);
								}
								answer = answer + this.formOption[i] + ",";
							} else {
								answer = answer + "不会" + ",";
								this.data[this.page - 1].title = this.data[this.page - 1].title.replace("_____", "<span style='color:red'>不会</span>");
							}
						}
						answer = answer.substring(0, answer.lastIndexOf(","));
						// //console.log(answer);
					} else {
						this.data[this.page - 1].title = this.data[
							this.page - 1
						].title.replace("_____", "<span style='color:red'>不会</span>");
						this.fillInTheBlankAnswer[0] = this.data[this.page - 1].answer;
						answer = "不会";
					}
				} else if (this.multipleChoicesQuestions.includes(this.data[this.page - 1].genre)) {//多选题
					this.right = this.data[this.page - 1].answer.split(",");
					answer = "不会";
				} else {//单选题
					answer = "不会";
				}
				// //console.log(answer);
				this.saveAnswer(answer); //保存答案
				this.answerArray[this.page] = answer;
				this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
			},
			//保存答案
			saveAnswer(answer_) {
				var page = this.page - 1;
				this.cacheAnswer[page] = {};
				this.cacheAnswer[page]["id"] = this.data[page].id;
				this.cacheAnswer[page]["text"] = this.data[page].text;
				this.cacheAnswer[page]["title"] = this.data[page].title;
				this.cacheAnswer[page]["score"] = this.data[page].score;
				this.cacheAnswer[page]["pid"] = this.data[page].pid;
				this.cacheAnswer[page]["genre"] = this.data[page].genre;
				this.cacheAnswer[page]["analysis"] = this.data[page].analysis;
				this.cacheAnswer[page]["option"] = this.data[page].option;
				this.cacheAnswer[page]["icon"] = this.data[page].icon;
				this.cacheAnswer[page]["genre_type"] = this.data[page].name;
				this.cacheAnswer[page]["user_res"] = answer_;
				this.cacheAnswer[page]["succ_res"] = this.data[page].answer;
				if (answer_ === this.data[page].answer || answer_ === "会") {
					this.cacheAnswer[page]["res"] = 1;
				} else {
					this.cacheAnswer[page]["res"] = 0;
				}
				localStorage.setItem("answerOptions", JSON.stringify(this.cacheAnswer));
				// //console.log(JSON.parse(localStorage.getItem("answerOptions")));
			},
			//会和不会
			meetingWillNot(e) {
				var that = e.currentTarget;
				var answer = $(that).children("xmp").text();
				if (answer === "会") {
					$(that).addClass("right");
				} else {
					$(that).addClass("wrong");
				}
				$(that).siblings().removeClass("right");
				this.answerArray[this.page] = answer;
				this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
				//多空填空题start
				var num = this.data[this.page - 1].title.split("_____").length - 1;
				if (num > 1) {
					//多空填空题
					var tk = "";
					for (var i = 0; i < num; i++) {
						tk = tk + "不会" + ",";
					}
					answer = tk.substring(0, tk.lastIndexOf(","));
				}
				//多空填空题end
				// //console.log(answer);
				this.saveAnswer(answer);

				if (answer === "会") {
					this.nextQuestion();
				} else {
					if (
						this.fillInTheBlankQuestionType.includes(
							this.data[this.page - 1].genre
						)
					) {
						//填空题
						var num = this.data[this.page - 1].title.split("_____").length - 1;
						if (num > 1) {
							//多空
							var dd = this.data[this.page - 1].answer.split(",");
							for (var i = 0; i < num; i++) {
								this.fillInTheBlankAnswer[i] = dd[i];
								if (this.formOption[i]) {
									if (dd[i] == this.formOption[i].replace(/(^\s*)|(\s*$)/g, "")) {
										this.data[this.page - 1].title = this.data[
											this.page - 1
										].title.replace(
											"_____",
											"<span style='color:skyblue'>" +
											this.formOption[i] +
											"</span>"
										);
									} else {
										this.data[this.page - 1].title = this.data[
											this.page - 1
										].title.replace(
											"_____",
											"<span style='color:red'>" + this.formOption[i] + "</span>"
										);
									}
									answer = answer + this.formOption[i] + ",";
								} else {
									answer = answer + "不会" + ",";
									this.data[this.page - 1].title = this.data[
										this.page - 1
									].title.replace("_____", "<span style='color:red'>不会</span>");
								}
							}
							answer = answer.substring(0, answer.lastIndexOf(","));
							// //console.log(answer);
						} else {
							this.data[this.page - 1].title = this.data[
								this.page - 1
							].title.replace("_____", "<span style='color:red'>不会</span>");
							this.fillInTheBlankAnswer[0] = this.data[this.page - 1].answer;
							answer = "不会";
						}
					}
					this.right = this.data[this.page - 1].answer.split(",");
					this.showParsing = true;
					this.showNote = true;
				}
			},
			//单选题
			multipleChoice(e) {
				var that = e.currentTarget;
				$(that).addClass("right");
				$(that).siblings().removeClass("right");
				var answer = $(that).children("em").text();
				this.answerArray[this.page] = answer;
				this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
				this.saveAnswer(answer);
				if (answer == this.data[this.page - 1].answer) {
					this.nextQuestion();
				} else {
					this.showParsing = true;
					this.showNote = true;
				}
			},
			//多选题
			multipleChoices(e) {
				var that = e.currentTarget;
				$(that).toggleClass("right");
				var answer = $(that).parent().children("p.right").children("em").text();
				this.correctAnswer = answer.split("");
				var dd = "";
				for (var i = 0; i < answer.split("").length; i++) {
					dd += answer.split("")[i] + ",";
				}
				dd = dd.substring(0, dd.lastIndexOf(","));
				//console.log(dd)
				this.answerArray[this.page] = dd;
			},
			//多选题确定
			multipleChoicesDetermine(e) {
				if (!this.answerArray[this.page]) {
					this.$message({
						type: "error",
						message: "请先选择答案",
						showClose: true,
					});
					return;
				}
				// //console.log(this.answerArray[this.page]);
				this.saveAnswer(this.answerArray[this.page]);
				// this.answerTrueArray[this.page] = this.data[this.page - 1].answer;
				var that = e.currentTarget;
				$(that).parent().prev().children("p.right").removeClass("right");
				if (this.answerArray[this.page] == this.data[this.page - 1].answer) {
					//答案正确
					this.right = this.data[this.page - 1].answer.split(",");
					this.nextQuestion();
				} else {
					this.right = this.data[this.page - 1].answer.split(",");
					var user = this.answerArray[this.page].split(",");
					for (var i = 0; i < user.length; i++) {
						if (this.right.includes(user[i])) {
							//有加半正确样式
							this.cover[i] = user[i];
						} else {
							//没有加错误样式
							this.wrong[i] = user[i];
						}
					}
					this.showParsing = true;
					this.showNote = true;
				}
			},
			//填空题
			fillInTheBlank() {
				if (JSON.stringify(this.formOption) == "{}") {
					this.$message({
						type: "error",
						message: "请先填写答案",
						showClose: true,
					});
					return;
				}
				this.showParsing = true;
				this.showNote = true;
				var num = this.data[this.page - 1].title.split("_____").length - 1;
				if (num > 1) {
					//多空填空题
					var dd = this.data[this.page - 1].answer.split(",");
					// //console.log(dd);
					var tk = "";
					for (var i = 0; i < num; i++) {
						this.fillInTheBlankAnswer[i] = dd[i];
						if (this.formOption[i]) {
							tk = tk + this.formOption[i] + ",";
							if (dd[i] == this.formOption[i].replace(/(^\s*)|(\s*$)/g, "")) {
								this.data[this.page - 1].title = this.data[
									this.page - 1
								].title.replace(
									"_____",
									"<span style='color:skyblue'>" + this.formOption[i] + "</span>"
								);
							} else {
								this.data[this.page - 1].title = this.data[
									this.page - 1
								].title.replace(
									"_____",
									"<span style='color:red'>" + this.formOption[i] + "</span>"
								);
							}
						} else {
							tk = tk + "未作答" + ",";
							this.data[this.page - 1].title = this.data[
								this.page - 1
							].title.replace("_____", "<span style='color:red'>未作答</span>");
						}
					}
					tk = tk.substring(0, tk.lastIndexOf(","));
					// //console.log(tk)
					this.saveAnswer(tk);
					this.answerArray[this.page] = tk;
					if (tk == this.data[this.page - 1].answer) {
						this.nextQuestion();
					}
				} else {
					if (
						this.data[this.page - 1].answer ==
						this.formOption[0].replace(/(^\s*)|(\s*$)/g, "")
					) {
						this.data[this.page - 1].title = this.data[
							this.page - 1
						].title.replace(
							"_____",
							"<span style='color:skyblue'>" + this.formOption[0] + "</span>"
						);
					} else {
						this.data[this.page - 1].title = this.data[
							this.page - 1
						].title.replace(
							"_____",
							"<span style='color:red'>" + this.formOption[0] + "</span>"
						);
					}
					this.fillInTheBlankAnswer[0] = this.data[this.page - 1].answer;
					this.saveAnswer(this.formOption[0]);
					this.answerArray[this.page] = this.formOption[0];
					if (this.formOption[0] == this.data[this.page - 1].answer) {
						this.nextQuestion();
					}
				}
			},

			//下一题
			nextQuestion() {
				if (this.page === this.count) {
					//最后一题
					this.stopKeepTime();
				} else {
					this.page++;
					this.setHeight();
					this.whetherToExpandTheAnalysis(); //是否展开解析
				}
			},

			//上一题
			previousQuestion() {
				this.page--;
				this.setHeight();
				this.whetherToExpandTheAnalysis(); //是否展开解析
			},

			setHeight() {
				this.titleHeight = this.$refs["xmpHeight"][this.page - 1].offsetHeight;
			},

			//点击序号跳转
			Answersheet(index_) {
				this.page = index_;
				this.whetherToExpandTheAnalysis(); //是否展开解析
			},
			// 展开文章
			setTitleUnfold() {
				if (this.isUnfold) {
					this.isUnfold = false;
					this.setTitleText = "展开文章";
				} else {
					this.isUnfold = true;
					this.setTitleText = "收起文章";
				}
			},
			//纠错
			openWrongWin() {
				this.showWrongWin = true;
			},
			//纠错
			errorCorrection(id_) {
				var param = {
					uid: this.user_id,
					qid: this.data[this.page - 1].id,
					text: this.wrongValue,
				};
				this.$post("errorCorrection", param).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: "success",
							message: "提交成功！感谢你的反馈，我们会在第一时间处理你的意见",
							showClose: true,
						});
						this.wrongValue = "";
					} else {
						this.$message({
							type: "error",
							message: "提交失败！请稍后重试",
							showClose: true,
						});
					}
					this.showWrongWin = false;
				});
			},
			getuserid(){
				this.userid=localStorage.getItem("userId")
			},
			//收藏
			setCollect() {
				var dd = this.data[this.page - 1].favorite;
				if (dd === 0) {
					var param = {
						uid: this.user_id,
						tid: 4,
						gid: this.data[this.page - 1].id,
						sub_id: this.sub_id,
						answer_id: this.ques_id,
						create_time: Date.parse(new Date()) / 1000,
						update_time: Date.parse(new Date()) / 1000,
					};
					this.$post("addfavorite", param).then((res) => {
						if (res.code === 200) {
							this.$message({
								type: "success",
								message: "收藏成功!",
								showClose: true,
							});
						}
					});
					this.data[this.page - 1].favorite = 1;
				} else {
					//收藏过
					this.$confirm("是否要取消收藏？", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						})
						.then(() => {
							//点击确定
							var param = {
								uid: this.user_id,
								qid: this.data[this.page - 1].id,
							};
							this.$post("deletefavorite", param).then((res) => {
								if (res.code === 200) {
									this.$message({
										type: "success",
										message: "删除成功!",
										showClose: true,
									});
									this.data[this.page - 1].favorite = 0;
								} else {
									this.$message({
										type: "success",
										message: "删除失败，请稍后重试!",
										showClose: true,
									});
								}
							});
						})
						.catch(() => {});
				}
			},
			//加载更多笔记
			loadMoreNotes(index_) {
				this.numberOfNotes++;
				var sid = this.data[this.page - 1].id;
				var param = {
					sid: sid,
					page: this.numberOfNotes,
				};
				this.$post("numberOfNotes", param).then((res) => {
					if (res.code === 200) {
						this.data[this.page - 1].note = this.data[this.page - 1].note.concat(
							res.data
						);
					} else {
						this.$message({
							type: "error",
							message: "没有更多笔记了！",
							showClose: true,
						});
					}
				});
			},

			//保存笔记
			addnote() {
				if (this.noteValue == "") {
					this.$message({
						type: "error",
						message: "笔记不能为空！",
						showClose: true,
					});
					return;
				}
				var param = {
					sid: this.data[this.page - 1].id,
					uid: this.user_id,
					content: this.noteValue,
				};

				this.$post("addnote", param).then((res) => {
					// //console.log(res);
					if (res.code == 200) {
						this.getInitialData();
						this.$message({
							type: "success",
							message: "request succeeded！",
							showClose: true,
						});
						this.noteValue = ""; //清空输入框
					} else {
						this.$message({
							type: "error",
							message: "request succeeded！",
							showClose: true,
						});
					}
				});
			},

			//删除笔记
			deleteNote(id_) {
				this.$confirm("您确定要删除笔记吗？", "删除", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$post("deletenote", {
							id: id_,
						}).then((res) => {
							if (res.code === 200) {
								this.getInitialData();
								this.$message({
									type: "success",
									message: "request succeeded！",
									showClose: true,
								});
							} else {
								this.$message({
									type: "error",
									message: "request failed！please try again later",
									showClose: true,
								});
							}
						});
					})
					.catch(() => {});
			},

			keepTime() {
				//定义计时函数
				this.s = this.s + 1;
				if (this.s >= 60) {
					this.s = 0;
					this.m = this.m + 1; //分钟
				}
				if (this.m >= 60) {
					this.m = 0;
					this.h = this.h + 1; //小时
				}
				this.timeStr =
					this.toDub(this.h) +
					":" +
					this.toDub(this.m) +
					":" +
					this.toDub(this.s);
			},

			resetTime() {
				//重置
				clearInterval(this.time);
				this.h = 0;
				this.m = 0;
				this.ms = 0;
				this.s = 0;
				this.timeStr = "00:00:00";
			},

			startTime() {
				//开始
				this.timer = setInterval(this.keepTime, 1000);
			},

			stopTime() {
				//暂停
				clearInterval(this.timer);
			},

			toDub(n) {
				//补0操作
				if (n < 10) {
					return "0" + n;
				} else {
					return "" + n;
				}
			},
			//点赞笔记
			praiseNote(e, id_) {
				this.$api.userNotePraise({id:id}).then((res)=>{
									this.viewResolution(id,'u')
									}
				)},
			//顶部面包屑
			cateCrumbs() {
				var param = {
					sub_id: this.sub_id,
				};
				this.$post("cateCrumbs", param).then((res) => {
					// //console.log(res);
					this.path = res.data.city + "-" + res.data.path;
					this.category_name = res.data.nname;
					this.chapter = res.data.cname;
					this.chapter_sub = res.data.name;
					this.ques_id = res.data.ques_id; //587593
				});
			},
			//获取相关图书
			recommendationRelated() {
				var param = {
					sid: this.sub_id,
					city: localStorage.getItem("indexRegionId"),
				};
				this.$post("recommendationRelated", param).then((res) => {
					//console.log(res);
					this.book = res.data;
				});
			},
			//跳转到外部链接
			jump(id) {
				window.open("https://www.sz517.com/tsxq/" + id, "_blank");
			},
			//是否展开解析
			whetherToExpandTheAnalysis() {
				this.noteValue = '';
				this.right = [];
				this.wrong = [];
				this.cover = [];
				this.formOption = {};
				if (this.cacheAnswer[this.page - 1]) {
					//答过题
					if (this.multipleChoicesQuestions.includes(this.data[this.page - 1].genre)) {
						//多选题型
						if (this.answerArray[this.page] == this.data[this.page - 1].answer) {
							//答案正确
							this.right = this.data[this.page - 1].answer.split(",");
						} else {
							this.right = this.data[this.page - 1].answer.split(",");
							var user = this.answerArray[this.page].split(",");
							for (var i = 0; i < user.length; i++) {
								if (this.right.includes(user[i])) {
									//有加半正确样式
									this.cover[i] = user[i];
								} else {
									//没有加错误样式
									this.wrong[i] = user[i];
								}
							}
						}
					}
					this.showParsing = true;
					this.showNote = true;
				} else {
					//
					this.showParsing = false;
					this.showNote = false;
				}
				this.noteValues();
			},
			//默认笔记文本
			noteValues() {
				var that = this;
				// //console.log(this.data);
				that.data[that.page - 1].note.forEach(function(v, k) {
					if (v.uid == that.user_id) {
						that.noteValue = v.content;
						// throw Error();
					}
				});
			},
		},

		watch: {
			ques_id: function() {
				this.$nextTick(() => {
					this.getInitialData();
					this.recommendationRelated();
				});
			},
			data() {
				this.$nextTick(() => {
					this.setHeight();
				});
			},
			page() {
				this.$nextTick(() => {
					this.setHeight();
					this.isUnfold = false;
					this.setTitleText = "展开文章";
				});
			},
		},
	};
</script>

<style>
	.el-dialog {
		border-radius: 10px !important;
	}
</style>
